import { Component, Input, OnInit } from '@angular/core';
import find from 'lodash-es/find';

@Component({
    selector: 'finder-dining-plan',
    templateUrl: './plan.component.html',
    styleUrls: ['./plan.component.scss']
})
export class DiningPlanComponent implements OnInit {

    @Input() mealPeriods: Array<string>;
    @Input() mealPeriodClass: string;
    @Input() notAccepted: string;
    @Input() plan: any;

    constructor() { }

    ngOnInit() {
        if (!this.mealPeriods) {
            return;
        }

        this.checkMealPeriodsNotAccepted();
    }

    checkMealPeriodsNotAccepted() {
        this.mealPeriods.forEach((mealPeriod, index) => {
            // Plan entitlements per year
            this.plan.entitlements.forEach(entitlements => {
                // Add meal period not accepted
                if (!find(entitlements, ['mealPeriod', mealPeriod])) {
                    entitlements.splice(index, 0, {
                        mealPeriod,
                        quantity: this.notAccepted
                    });
                }
            });
        });
    }
}
